import AppSecureStorage from "../services/storage/secureStorage";
const storage = new AppSecureStorage();

export const getAuthToken = () => {
    return  storage.getItem('token')
};

export const getCurrentUser = () => {
    return  storage.getItem('currentUser')
};

export const getCurrentUserAavtar = () => {
    return  storage.getItem('avatar')
};

export const getUserUpdationData=()=>{
    return storage.getItem('userUpdation')
}